<script>
import {onBeforeUnmount, onMounted, ref} from "vue";
import {useRoute} from "vue-router";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import {useStore} from "vuex";
import Swal from "sweetalert2";
import $ from "jquery";
import FreeWorld from "@/assets/js/FreeWorld";
import NavbarPage from "@/components/assetComponents/NavbarPage.vue";
import Swals from "@/assets/js/Swals";

export default {
  name: "AdvertisingPage",
  components: {NavbarPage, LoadingPage},

  setup() {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0

    let store = useStore()

    let loading = ref(false)

    let page = ref('one')

    let page_name = ref(useRoute().params.name)
    let cat_id = useRoute().params.cat_id
    // let sub_cat_id = useRoute().params.sub_cat_id

    let page_type = ref('employer')

    let data_filter = ref({
      category_id: cat_id,
      request_person: null,
      type_partnership_id: null,
      experience_id: null,
      payment_id: null,
      bime_id: null,
      military_id: null,
      state_id: null,
      city_id: null,
      // street_id: null,
    })

    let check_filter = ref({
      filter: false,
      count: 0,
    })

    let consultants_lenght = ref({
      employer: 0 ,
      job_seeker: 0
    })

    let sub_cat_filter = ref([])

    let advertisementss = ref([])
    let advertisements = ref([])

    let input_search = ref()

    let country = ref([])
    let citys = ref([])
    // let streets = ref([])

    let place = ref({
      city_name: null,
      // street_name: null,
    })
    let page_select_place = ref('state')

    let filters = ref([])

    let save_data = store.state.filter.advertising


    function load_jobSearch(action) {

      if (action == 'delete_filter') {

        data_filter.value = {
          category_id: cat_id,
          request_person: null,
          type_partnership_id: null,
          experience_id: null,
          payment_id: null,
          bime_id: null,
          military_id: null,
          state_id: null,
          city_id: null,
          // street_id: null,
        }

        filters.value.forEach((item) => {
          item.myselect = null
        })

        advertisements.value = []
        check_filter.value.filter = false
        check_filter.value.count = 0
        place.value.city_name = null
        // place.value.street_name = null
        page.value = 'one'

        store.commit('set_filter_advertising' , 'delete')
      }

      let data = {
        category_id: cat_id,
      }


      loading.value = true

          FreeWorld.Heisenberg(data , 'advers' , true).then((result) => {

        loading.value = false
        let res = result.data
        advertisements.value = res
        advertisementss.value = res

        res.forEach((item) => {
          if (item.request_person == 'کارفرما') {
            consultants_lenght.value.employer++
          } else {
            consultants_lenght.value.job_seeker++
          }
        })

      }).catch((result) => {

        loading.value = false
        if (result.message == 'Network Error') {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'تلاش مجدد',
            text: 'لطفا فیلتر شکن را خاموش کرده یا وضعیت اینترنت را برسی کنید',
          }).then((result) => {
            if (result.isConfirmed) {
              load_jobSearch(action)
            }
          })
        } else {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'تلاش مجدد',
            text: '!خطای ارتباط با سرور',
          }).then((result) => {
            if (result.isConfirmed) {
              load_jobSearch(action)
            }
          })
        }
      })

    }
    function load_filter() {

      if (save_data == null ){

        loading.value = true
        FreeWorld.Heisenberg({} , 'adver_filter').then((result) => {

          loading.value = false
          let res = result.data
          filters.value = res.filter

          filters.value.forEach((item) => {
            item.myselect = null
          })

        }).catch((res) => {
          loading.value = false
        Swals.Catch(res , load_filter)
        })

      }

    }
    load_filter()

    function get_country() {
      loading.value = true

      FreeWorld.Heisenberg({}, 'user/city').then((res) => {

        loading.value = false
        country.value = res.data.results

      }).catch((result) => {
        loading.value = false
        Swals.Catch(result, get_country)
      })
    }
    get_country()

    function change_filter() {

      data_filter.value = save_data.data_filter
      filters.value = save_data.filters
      place.value = save_data.place

      set_filter()

    }

    if (save_data != null){
      change_filter()
    }else{
      load_jobSearch()
    }


    function search_prod() {
      advertisements.value = []
      advertisementss.value.forEach((item) => {
        if (item.adver_name.includes(input_search.value)) {
          advertisements.value.push(item)
        }
      })
    }

    function open_search() {
      var input_search = document.getElementById('input_search')

      if (input_search.style.width != '120px') {
        input_search.style.width = '120px'
      } else {
        input_search.style.width = '0px'
      }
    }

    // function open_select_place() {
    //
    //   let alert = document.getElementById('select_state')
    //   let background = document.getElementById('alert_background_place')
    //   page_select_place.value = 'state'
    //
    //
    //   if (country.value[0] != null) {
    //
    //     if (alert.style.display != 'block') {
    //       alert.style.display = 'block'
    //       background.style.display = 'block'
    //     } else {
    //
    //       if (place.value.street_name == null) {
    //         place.value.street_name = null
    //         place.value.city_name = null
    //         // data.value.state_id = null
    //         // data.value.city_id = null
    //         // data.value.street_id = null
    //       }
    //       alert.style.display = 'none'
    //       background.style.display = 'none'
    //     }
    //
    //   } else {
    //
    //     Swal.fire({
    //       icon: 'error',
    //       confirmButtonText: 'تلاش مجدد',
    //       text: '!از اتصال تلفن خود به اینترنت اطمینان حاصل فرمایید',
    //     }).then((result) => {
    //       if (result.isConfirmed) {
    //         load_jobSearch()
    //       }
    //     })
    //
    //   }
    //
    //
    // }

    function open_select_place() {

      let alert = document.getElementById('select_state')
      let background = document.getElementById('alert_background_place')


      if (alert.style.display != 'block') {

        $("#select_state").removeClass('animate__fadeOut')
        $("#select_state").addClass('animate__fadeIn')
        alert.style.display = 'block'
        background.style.display = 'block'

      } else {

        if (place.value.city_name == null) {
          // place.value.street_name = null
          place.value.city_name = null
          data_filter.value.state_id = null
          data_filter.value.city_id = null
          // data_filter.value.street_id = null
        }

        $("#select_state").addClass('animate__fadeOut')
        setTimeout(()=>{
          alert.style.display = 'none'
          background.style.display = 'none'
          page_select_place.value = 'state'
        },600)

      }
    }

    function change_country(status, id, name) {

      if (status == 'state') {

        if (id !== -1) {
          country.value.forEach((item) => {
            if (id == item.id) {
              citys.value = item.city
            }
          })
          data_filter.value.state_id = id
          page_select_place.value = 'city'
        }
        else{
          data_filter.value.state_id = id
          place.value.city_name = 'همه ی استان ها'
          open_select_place()
        }

      } else if (status == 'city') {

        // citys.value.forEach((item) => {
        //   if (id == item.id) {
        //     streets.value = item.street
        //   }
        // })
        // page_select_place.value = 'street'

        data_filter.value.city_id = id
        place.value.city_name = name
        open_select_place()

      }
      // else if (status == 'all_street') {
      //   place.value.street_name = 'همه خیابان ها'
      //   data_filter.value.street_id = -1
      //   open_select_place()
      // } else if (status == 'street') {
      //   place.value.street_name = name
      //   data_filter.value.street_id = id
      //   open_select_place()
      // }

    }

    function set_filter() {

      filters.value.forEach((item) => {

        if (item.name == 'نوع همکاری') {

          data_filter.value.type_partnership_id = item.myselect

        }

        if (item.name == 'وضعیت سربازی') {

          data_filter.value.military_id = item.myselect

        }

        if (item.name == 'بیمه') {

          data_filter.value.bime_id = item.myselect

        }

        if (item.name == 'شیوه پرداخت') {

          data_filter.value.payment_id = item.myselect

        }

        if (item.name == 'نیاز به سابقه') {

          data_filter.value.experience_id = item.myselect

        }

      })

      loading.value = true
      FreeWorld.Heisenberg(data_filter.value , 'advers' , true).then((result) => {

        let data_save = {
          data_filter:data_filter.value,
          place:place.value,
          filters:filters.value,
        }
        store.commit('set_filter_advertising' , data_save)

        loading.value = false
        let res = result.data
        advertisements.value = res
        advertisementss.value = res

        res.forEach((item) => {
          if (item.request_person == 'کارفرما') {
            consultants_lenght.value.employer++
          } else {
            consultants_lenght.value.job_seeker++
          }
        })

        check_filter.value.filter = true

        let i = []

        for (var x in data_filter.value) {
          // console.log(x +':'+ data_filter.value[x])
          if (data_filter.value[x] != null) {
            i.push(data_filter.value[x])
          }
        }
        // if (data_filter.value.street_id != null ){
        //   check_filter.value.count = i.length - 5
        // }else{
        // }
        check_filter.value.count = i.length - 4

        page.value = 'one'

      }).catch((result) => {

        loading.value = false
        if (result.message == 'Network Error') {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'تلاش مجدد',
            text: 'لطفا فیلتر شکن را خاموش کرده یا وضعیت اینترنت را برسی کنید',
          }).then((result) => {
            if (result.isConfirmed) {
              set_filter()
            }
          })
        } else {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'تلاش مجدد',
            text: '!خطای ارتباط با سرور',
          }).then((result) => {
            if (result.isConfirmed) {
              set_filter()
            }
          })
        }
      })

    }

    let scroll = false

    onMounted(() => {
      scroll = true
    })
    onBeforeUnmount(() => {
      scroll = false
    })

    window.addEventListener('scroll', () => {
      const scrollPosition = window.scrollY;
      // اگر کاربر به پایین اسکرول کرده باشد، کلاس hidden اضافه شود، در غیر این صورت حذف شود
      if (scroll) {
        scrollPosition > 150 ? $("#add_icon").removeClass('animate__fadeInUpBig').addClass('animate__fadeOutDownBig') : $("#add_icon").removeClass('animate__fadeOutDownBig').addClass('animate__fadeInUpBig')
      }
    });



    return {

      open_search,
      page,
      page_name,
      page_type,
      loading,
      advertisements,
      open_select_place,
      citys,
      // streets,
      country,
      place,
      page_select_place,
      filters,
      data_filter,
      change_country,
      load_jobSearch,
      sub_cat_filter,
      set_filter,
      check_filter,
      input_search,
      search_prod,
      consultants_lenght,

    }
  }
}
</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>
  <div @click="open_select_place" id="alert_background_place" class="alert_background"></div>
  <div dir="ltr" v-if="country[0] != null " id="select_state" class="animate__animated px-5 mt-3 max_width">
    <div class="bg-white rounded-4 border-costom">
      <div class="bg-color-liner position-relative rounded-top-4 d-flex justify-content-center align-items-center">
        <img @click="open_select_place" class="icon_closing_filter position-absolute" style="width: 15px"
             src="../assets/img/closing.svg" alt="">
        <img class="py-4" style="width: 100px" src="../assets/img/location_white.svg" alt="">
      </div>

      <div v-if="page_select_place === 'state' " class="px-2 py-3 overflow-y-scroll" style="height: 400px">

        <div @click="change_country('state', -1)" class="d-flex justify-content-between py-3">
          <img class="m-0 mx-2" style="width: 8px" src="../assets/img/down-arrow.svg" alt="">

          <p class="m-0">همه استان ها</p>
        </div>

        <div v-for="item in country" :key="item.id" @click="change_country('state', item.id)" class="d-flex justify-content-between py-3">
          <img class="m-0 mx-2" style="width: 8px" src="../assets/img/down-arrow.svg" alt="">

          <p class="m-0">{{ item.name }}</p>
        </div>

      </div>

      <div v-if="page_select_place === 'city' " class="px-2 py-3 overflow-y-scroll" style="height: 400px">

        <div @click="change_country('city', -1 , 'همه ی شهر ها')" class="d-flex justify-content-between py-3">
          <img class="m-0 mx-2" style="width: 8px" src="../assets/img/down-arrow.svg" alt="">

          <p class="m-0">همه شهر ها</p>
        </div>

        <div v-for="item in citys" :key="item.id" @click="change_country('city', item.id , item.name)"
             class="d-flex justify-content-between py-3">
          <img class="m-0 mx-2" style="width: 8px" src="../assets/img/down-arrow.svg" alt="">

          <p class="m-0">{{ item.name }}</p>
        </div>

      </div>

      <!--        <div v-if="page_select_place == 'street' " class="px-2 py-3 overflow-y-scroll" style="height: 400px">-->

      <!--          <div @click="change_country('all_street')" class="d-flex justify-content-between py-3">-->
      <!--            <img class="m-0 mx-2" style="width: 8px" src="../assets/img/down-arrow.svg" alt="">-->
      <!--            <p class="m-0 font-5">همه خیابان ها</p>-->
      <!--          </div>-->

      <!--          <div v-for="item in streets" :key="item.id" @click="change_country('street', item.id , item.name)"-->
      <!--               class="d-flex justify-content-between py-3">-->
      <!--            <img class="m-0 mx-2" style="width: 8px" src="../assets/img/down-arrow.svg" alt="">-->
      <!--            <p class="m-0 font-5">{{ item.name }}</p>-->
      <!--          </div>-->

      <!--        </div>-->

    </div>
  </div>


  <div dir="ltr" id="main" class="bg-main" :class="loading ? 'activeClass' : '' ">

    <div v-if="page == 'one' " :class="loading ? 'activeClass' : '' " dir="ltr" id="main" class="bg-main">

      <div class="div-top-arrow bg-color d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">

          <div @click="page = 'filter' " class="position-relative">
            <div v-if="check_filter.filter && check_filter.count != 0 "
                 class="py-1 px-2 rounded-pill bg-danger position-absolute d-flex justify-content-center align-items-center">
              <p class="m-0 font-6 text-white">{{ check_filter.count }}</p>
            </div>
            <img style="width: 3rem" src="../assets/img/setting_icon_no_shadow.svg"
                 alt="">
          </div>

          <div class="d-flex align-items-center position-relative">
            <img @click="open_search" style="width: 3rem" class="z-1 mx-2" src="../assets/img/search_bg-white.svg" alt="">
            <input v-model="input_search" @input="search_prod" id="input_search" class="input_search font-5 text-center bg-white" type="text" placeholder="جستجو">
          </div>

        </div>

        <div class="d-flex align-items-center">

          <p class="m-0 font-4">
            آگهی های {{ page_name }}
          </p>

          <div onclick="history.back()">
            <img class="svg-arrow" src="../assets/img/back.svg" alt="">
          </div>

        </div>
      </div>
      <br>
      <br>
      <br>

      <div class="p-3">
        <div class="d-flex justify-content-evenly">

          <v-btn @click="page_type = 'job_seeker' "
                 :class="page_type != 'job_seeker' ? 'bg-unavailable text-black' : 'bg-color' "
                 class="rounded-4 h-75 p-3 font-4 text-white border-costom w-45">
            جویای کار
          </v-btn>

          <v-btn @click="page_type = 'employer' "
                 :class="page_type != 'employer' ? 'bg-unavailable text-black' : 'bg-color' "
                 class="rounded-4 h-75 p-3 font-4 text-white border-costom w-45 ">
            استخدام نیرو
          </v-btn>

        </div>
      </div>

      <div v-if="page_type == 'employer' " class="p-body">

        <div v-if="consultants_lenght.employer == 0 || advertisements.length == 0 "
             class="p-body w-100 d-flex flex-column justify-content-center align-items-center"
             style="height: 60vh">
          <div class="d-flex flex-column align-items-center">
            <img style="width: 70px" src="../assets/img/shop_none.svg" alt="">
            <br>
            <p class="font-4 ">
              در حال حاضر آگهی وجود ندارد...
            </p>
          </div>
        </div>

        <div v-else v-for="item in advertisements" :key="item.id">

          <router-link :to="{name:'DetailsAdvertising' , params:{adver_id:item.id}}" v-if="item.request_person == 'کارفرما' "
                       class="animate__animated animate__fadeIn rounded-shaped d-flex justify-content-between text-decoration-none shadow-costom bg-white mb-2 rounded-4 p-2">

            <div class="w-60 px-2 py-2">
              <p class="font-4 font-bold text-end">{{ item.adver_name }}</p>
              <p class="text_information font-5">{{ item.description }}</p>
              <p class="m-0 font-5 text-end">
                <span>{{ item.state }}</span>
                -
                <span>{{ item.city }}</span>
              </p>
            </div>
            <div class="w-40 rounded-4 animated-background">
              <img v-if="!item.pic[0]" class="img_executives rounded-4" src="../assets/img/img-notavalible.jpg" alt="">
              <img v-else class="img_executives rounded-4" :src="item.pic[0]" alt="">
            </div>

          </router-link>

        </div>

      </div>


      <div v-if="page_type == 'job_seeker' " class="p-body">

        <div v-if="consultants_lenght.job_seeker == 0 || advertisements.length == 0 "
             class="p-body w-100 d-flex flex-column justify-content-center align-items-center"
             style="height: 60vh">
          <div class="d-flex flex-column align-items-center">
            <img style="width: 70px" src="../assets/img/shop_none.svg" alt="">
            <br>
            <p class="font-4 ">
              در حال حاضر آگهی وجود ندارد...
            </p>
          </div>
        </div>

        <div v-else v-for="item in advertisements" :key="item.id">

          <router-link :to="{name:'DetailsAdvertising' , params:{adver_id:item.id}}" v-if="item.request_person == 'کارجو' "
                       class="animate__animated animate__fadeIn rounded-shaped d-flex justify-content-between text-decoration-none shadow-costom bg-white mb-2 rounded-4 p-2">
            <div class="w-60 px-2 py-2">
              <p class="font-4 font-bold text-end">{{ item.adver_name }}</p>
              <p class="text_information font-5">{{ item.description }}</p>
              <p class="m-0 font-5 text-end">
                <span>{{ item.state }}</span>
                -
                <span>{{ item.city }}</span>
              </p>
            </div>
            <div class="w-40 animated-background rounded-3">
              <img v-if="!item.pic[0]" class="img_executives rounded-4" src="../assets/img/img-notavalible.jpg" alt="">
              <img v-else class="img_executives rounded-4" :src="item.pic[0]" alt="">
            </div>
          </router-link>

        </div>

      </div>

      <router-link :to="{name:'AddNewAdvertising' , params:{action:'new'}}" id="add_icon" class="animate__animated animate__fadeInUpBig text-decoration-none position-fixed bottom-5 d-flex flex-column align-items-center ms-3">
        <img style="width: 4.5rem" class="mb-2" src="../assets/img/icon-add.svg" alt="">
        <p class="font-5 m-0 font-color font-bold">ثبت آگهی</p>
      </router-link>

    </div>

    <div dir="ltr" v-if="page == 'filter' " id="main" :class="loading ? 'activeClass' : '' " class="bg-main">

      <div class="div-top-arrow bg-color d-flex align-items-center justify-content-between">
        <div @click="load_jobSearch('delete_filter')" class="d-flex align-items-center">
          <p class="m-0">
            انصراف
          </p>
          <img class="svg-arrow" src="../assets/img/closing.svg" alt="">
        </div>
        <div class="d-flex align-items-center">
          <p class="m-0">
            فیلتر
          </p>
          <div @click="page = 'one' " class="">
            <img class="svg-arrow" src="../assets/img/back.svg" alt="">
          </div>
        </div>
      </div>
      <br>
      <br>
      <br>

      <div class="p-body">
        <div class="p-3 bg-white rounded-3 mt-2">

          <div class=" d-flex justify-content-between align-items-center py-2">

            <div class="d-flex align-items-center w-60">
              <img style="width: 8px" src="../assets/img/down-arrow.svg" alt="">

                <p @click="open_select_place" v-if="place.city_name != null " class="m-0 font-5 d-flex align-items-center">{{ place.city_name }}</p>


              <p v-else @click="open_select_place" class="m-0 font-5 mx-2">
                همه
              </p>

            </div>

            <p class="m-0 font-4">
              محدوده آگهی
            </p>

          </div>

          <hr>

          <div v-for="item in filters" :key="item.id">

            <div class=" d-flex justify-content-between align-items-center py-2">
              <div class="d-flex align-items-center">
                <img style="width: 8px" src="../assets/img/down-arrow.svg" alt="">

                <select v-model="item.myselect" class="ml-2 font-5 w-100">
                  <option :value="null">همه</option>
                  <option v-for="items in item.sub" :key="items.id" :value="items.id"> {{ items.name }}</option>
                </select>

              </div>

              <p class="m-0 font-4">{{ item.name }}</p>

            </div>

            <hr>

          </div>

          <div class=" d-flex justify-content-between align-items-center py-2">
            <div class="d-flex align-items-center">
              <img style="width: 8px" src="../assets/img/down-arrow.svg" alt="">

              <select v-model="data_filter.request_person" class="ml-2 font-5 w-100">
                <option :value="null">همه</option>
                <option :value="1">کارفرما</option>
                <option :value="2">کارجو</option>
              </select>

            </div>
            <p class="m-0 font-4">
              آگهی دهنده
            </p>
          </div>

        </div>


      </div>

      <br>
      <br>

      <div class="button_div w-100 d-flex justify-content-center bg-main">
        <v-btn @click="set_filter" class="w-50 h-75 bg-color rounded-3 border-costom text-white my-2 ">
          اعمال فیلتر
        </v-btn>
      </div>
    </div>

  </div>

  <div id="web" class="bg-main" :class="loading ? 'activeClass' : '' ">

    <div>

      <NavbarPage></NavbarPage>

      <div class="d-flex justify-space-between position-relative">
        <div style="left: 0" class="w-75 position-absolute">
            <div class="d-flex justify-content-evenly">
              <v-btn @click="page_type = 'job_seeker' " :class="page_type != 'job_seeker' ? 'bg-unavailable text-black' : 'bg-color' " class="rounded-4 h-100 p-2 font-5 text-white border-costom w-30">
                جویای کار
              </v-btn>

              <v-btn @click="page_type = 'employer' " :class="page_type != 'employer' ? 'bg-unavailable text-black' : 'bg-color' " class="rounded-4 h-100 p-2 font-5 text-white border-costom w-30 ">
                استخدام نیرو
              </v-btn>
            </div>

          <br>
          <br>

          <div v-if="page_type === 'employer' " class="p-body list_products_web">

            <div v-if="consultants_lenght.employer == 0 || advertisements.length == 0 "
                 class="p-body w-100 d-flex flex-column justify-content-center align-items-center"
                 style="height: 60vh">
              <div class="d-flex flex-column align-items-center">
                <img style="width: 100px" src="../assets/img/shop_none.svg" alt="">
                <br>
                <p class="font-5 ">
                  در حال حاضر آگهی وجود ندارد...
                </p>
              </div>
            </div>

            <div v-else v-for="item in advertisements" :key="item.id" v-show="item.request_person.includes('کارفرما')" class="products_custom_web rounded-shaped mx-1 bg-white mb-2 rounded-4 animate__animated animate__fadeIn shadow-costom p-2">

              <router-link :to="{name:'DetailsAdvertising' , params:{adver_id:item.id}}" class="d-flex justify-content-between text-black text-decoration-none">
                <div class="div_img_products_web rounded-4 animated-background">
                  <img v-if="!item.pic[0]" class="w-100 h-100 rounded-4" src="../assets/img/img-notavalible.jpg" alt="">
                  <img v-else style="object-fit: cover" class="w-100 h-100 rounded-4" :src="item.pic[0]" alt="">
                </div>

                <div style="width: calc(100% - 10.5rem)" class="px-2 py-2 d-flex flex-column justify-content-around">
                  <p class="font-5 font-bold">{{ item.adver_name }}</p>
                  <p class="text_information font-4">{{ item.description }}</p>
                  <p class="m-0 font-4">
                    <span>{{ item.state }}</span>
                    -
                    <span>{{ item.city }}</span>
                  </p>
                </div>
              </router-link>

            </div>

          </div>

          <div v-if="page_type === 'job_seeker' " class="p-body list_products_web">

            <div v-if="consultants_lenght.job_seeker == 0 || advertisements.length == 0 "
                 class="p-body w-100 d-flex flex-column justify-content-center align-items-center"
                 style="height: 60vh">
              <div class="d-flex flex-column align-items-center">
                <img style="width: 100px" src="../assets/img/shop_none.svg" alt="">
                <br>
                <p class="font-5 ">
                  در حال حاضر آگهی وجود ندارد...
                </p>
              </div>
            </div>

            <div v-else v-for="item in advertisements" :key="item.id" v-show="item.request_person.includes('کارجو')" class="products_custom_web mx-1 rounded-shaped bg-white mb-2 rounded-4 animate__animated animate__fadeIn shadow-costom p-2">

              <router-link :to="{name:'DetailsAdvertising' , params:{adver_id:item.id}}" class="d-flex text-black justify-content-between text-decoration-none">
                <div class="div_img_products_web rounded-4 animated-background">
                  <img v-if="!item.pic[0]" class="w-100 h-100 rounded-4" src="../assets/img/img-notavalible.jpg" alt="">
                  <img v-else style="object-fit: cover" class="w-100 h-100 rounded-4" :src="item.pic[0]" alt="">
                </div>

                <div style="width: calc(100% - 10.5rem)" class="px-2 py-2 d-flex flex-column justify-content-around">
                  <p class="font-5 font-bold">{{ item.adver_name }}</p>
                  <p class="text_information font-4">{{ item.description }}</p>
                  <p class="m-0 font-4">
                    <span>{{ item.state }}</span>
                    -
                    <span>{{ item.city }}</span>
                  </p>
                </div>
              </router-link>

            </div>

          </div>

          <router-link :to="{name:'AddNewAdvertising' , params:{action:'new'}}" id="add_icon" class="animate__animated animate__fadeInUpBig text-decoration-none position-fixed bottom-5 d-flex flex-column align-items-center ms-3">
            <img style="width: 4.5rem" class="mb-2" src="../assets/img/icon-add.svg" alt="">
            <p class="font-5 m-0 font-color font-bold">ثبت آگهی</p>
          </router-link>
        </div>

        <div class="sidebar">

          <div class="font-5 text-right font-bold mt-7 mb-4 position-relative d-flex justify-space-between align-items-center px-4 py-2">
            <span @click="load_jobSearch('delete_filter')" class="p-2 item_hover">حذف فیلتر</span>

            <div class="position-relative">
              <span v-if="check_filter > 0" style="left: -2rem" class="position-absolute bg-danger font-4 rounded-pill px-2 py-1 text-white">{{ check_filter }}</span>
              <span class="">: فیلتر ها</span>
            </div>
          </div>


          <div class="p-body">
            <div class="p-3 bg-white rounded-3 mt-2">

              <div class=" d-flex justify-content-between align-items-center py-2">

                <div class="d-flex align-items-center">
                  <img style="width: 8px" src="../assets/img/down-arrow.svg" alt="">

                  <div @click="open_select_place" v-if="place.city_name != null " class="d-flex ml-2">

<!--                    <p class="m-0 font-4 d-flex align-items-center ">{{ place.street_name }}</p>-->

<!--                    <span class="mx-1">-</span>-->

                    <p class="m-0 font-6 d-flex align-items-center">{{ place.city_name }}</p>

                  </div>

                  <p v-else @click="open_select_place" class="m-0 font-6 mx-2">
                    همه
                  </p>

                </div>

                <p class="m-0 font-5">
                  محدوده آگهی
                </p>

              </div>

              <hr>

              <div v-for="item in filters" :key="item.id">

                <div class=" d-flex justify-content-between align-items-center py-2">
                  <div class="d-flex align-items-center">
                    <img style="width: 8px" src="../assets/img/down-arrow.svg" alt="">

                    <select v-model="item.myselect" class="ml-2 font-5 w-100">
                      <option :value="null">همه</option>
                      <option class="font-5" v-for="items in item.sub" :key="items.id" :value="items.id"> {{ items.name }}</option>
                    </select>

                  </div>

                  <p class="m-0 font-5">{{ item.name }}</p>

                </div>

                <hr>

              </div>

              <div class=" d-flex justify-content-between align-items-center py-2">
                <div class="d-flex align-items-center">
                  <img style="width: 8px" src="../assets/img/down-arrow.svg" alt="">

                  <select v-model="data_filter.request_person" class="ml-2 font-5 w-100">
                    <option class="font-5" :value="null">همه</option>
                    <option class="font-5" :value="1">کارفرما</option>
                    <option class="font-5" :value="2">کارجو</option>
                  </select>

                </div>
                <p class="m-0 font-5">
                  آگهی دهنده
                </p>
              </div>
            </div>
          </div>

          <br>
          <br>

          <div style="height:3rem" class="d-flex justify-center">
            <v-btn @click="set_filter" class="w-60 h-100 bg-color rounded-3 border-costom text-white">
              اعمال فیلتر
            </v-btn>
          </div>

          <br>
          <br>
          <br>
          <br>
          <br>
          <br>
          <br>
          <br>
        </div>
      </div>

      </div>

    </div>

</template>

<style scoped>

.input_search {
  height: 3rem;
  width: 0px;
  border-top-right-radius: 50px;
  border-bottom-right-radius: 50px;
  border: none;
  position: absolute;
  left: 50%;
  transition: 0.5s;
}
.img_executives {
  width: 100%;
  height: 150px;
}
.text_information {
  height: 57px;
  position: relative;
  width: 100%;
  white-space: pre-line;
  overflow: hidden;
  text-overflow: ellipsis;
  direction: rtl;
}
.button_div {
  height: 80px;
  position: fixed;
  bottom: 0;
  max-width: 700px;
}
#select_state {
  display: none;
  position: fixed;
  width: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 4;
}
.icon_closing_filter {
  top: 15px;
  left: 15px;
}
.alert_background {
  position: fixed;
  top: 0;
  height: 100vh;
  width: 100%;
  background-color: rgba(79, 78, 78, 0.7);
  display: none;
  z-index: 4;
}



.sidebar{
  position: fixed;
  right: 0;
  width: 25%;
  direction: ltr;
  height: 100%;
  overflow-y: scroll;
}
.list_products_web{
  display: flex;
  justify-content: space-between;
  padding: 0 2%;
  flex-wrap: wrap;
}
.products_custom_web {
  padding: 1rem;
  background-color: white;
  flex-basis: 49%;
  flex-grow: 0;
}

@media (max-width:1285px ) {
  .products_custom_web{
    min-width: 27rem;
    flex-grow: 1;
  }
}
.div_img_products_web {
  width: 10rem;
  height: 10rem;
  object-fit: cover;
}
.item_hover{
  transition: .5s;
  border-radius: 30px;
  padding: 1.5%;
  white-space: nowrap;
  overflow: visible;
  text-decoration: none;
  color:black;
}
.item_hover:hover{
  background-color: #818285;
  color: white;
  outline: 1px solid #e15900;
}
</style>